import { ArrayLoading, EntityLevel } from '@/store/types'

import { loading, none } from '@/store/constants'
import {
  Active,
} from '../editor/types'
import {
  ActiveUser,
  User,
} from './types'

import { blankEditBase } from '@/store/editor/constants'

import _ from 'lodash'

export const loadingUser: ArrayLoading<User> = _.assign([], loading)

// TODO: move to commmon?
export const active: Active = _.assign({ entityLevel: EntityLevel.None, isNone: false, id: -1, Name: '', DisplayName: '', Visible: true, OrderBy: 0, Created: false }, blankEditBase)

export const blankUser: User = _.assign({ UserId: -1, Username: '', Email: '', Password: '', DateCreated: new Date(), Disabled: false, Roles: [] }, blankEditBase)

export const activeUserNone: ActiveUser = _.assign({}, blankUser, active, none)
